// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"e606889b","239":"2ea9a76c","311":"47c2bdcd","455":"f5a887bb","582":"d4864a3c","838":"d7e07b75","845":"31f01df0","977":"ead65a9b"}[chunkId] + ".chunk.js";
};